import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {MedicalRecordVisitReasonModel} from '../../../api/model/medicalRecordVisitReason.model';

@Injectable({providedIn: 'root'})
export class MedicalRecordVisitReasonRepository extends AbstractRepositoryV2<MedicalRecordVisitReasonModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalRecordVisitReason', serviceElementsFactory, injector);
    }
}
